module.exports = __webpack_public_path__ + "img/top_gold_bg.124dafa4.png";